// ─── Environment Detection (same pattern as Bhagvali Arts url.js) ─────────────
const getEnvironment = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname?.startsWith("uat.")) {
    return "uat";
  } else {
    return "live";
  }
};

// ─── API URLs from .env ────────────────────────────────────────────────────────
// CRA uses process.env.REACT_APP_* (Vite uses import.meta.env.VITE_*)
export const LIVE_API_URL = process.env.REACT_APP_LIVE_API_URL;
export const UAT_API_URL = process.env.REACT_APP_UAT_API_URL;
// console.log("API URLs:", UAT_API_URL, LIVE_API_URL);

// ─── Active Base URL ───────────────────────────────────────────────────────────
// export const baseUrl = getEnvironment() === "uat" ? UAT_API_URL : LIVE_API_URL;
export const baseUrl = (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim()) || (getEnvironment() === "uat" ? UAT_API_URL : LIVE_API_URL);
export const env = getEnvironment();
console.log("Active API Base URL:", baseUrl);

// ─── Endpoint Map ─────────────────────────────────────────────────────────────
// About College — Governance
export const chairmanApi = `${baseUrl}/chairman`;
export const viceChairmanApi = `${baseUrl}/vice-chairman`;
export const registrarApi = `${baseUrl}/registrar`;
export const financeOfficerApi = `${baseUrl}/finance-officer`;
export const headsOfDepartmentsApi = `${baseUrl}/heads-of-departments`;
export const chiefProctorApi = `${baseUrl}/chief-proctor`;
export const deanStudentsWelfareApi = `${baseUrl}/dean-students-welfare`;

// About College — Admin Authorities
export const admissionCellApi = `${baseUrl}/admission-cell`;
export const hostelAdministratorsApi = `${baseUrl}/hostel-administrators`;
export const facultyAdministratorsApi = `${baseUrl}/faculty-administrators`;
export const proctorialOfficialsApi = `${baseUrl}/proctorial-officials`;

// About College — Committees
export const executiveCouncilApi = `${baseUrl}/executive-council`;
export const academicCouncilApi = `${baseUrl}/academic-council`;
export const financeCommitteeApi = `${baseUrl}/finance-committee`;

// About College — Content
export const historyApi = `${baseUrl}/history`;
export const visionMissionApi = `${baseUrl}/vision-mission`;
export const collegeAtGlanceApi = `${baseUrl}/college-at-glance`;
export const collegeKulgeetApi = `${baseUrl}/college-kulgeet`;
export const academicHeritageApi = `${baseUrl}/academic-heritage`;
export const termsAndConditionsApi = `${baseUrl}/terms-and-conditions`;

// Academics
export const academicCalendarApi = `${baseUrl}/academic-calendar`;
export const ugProgrammesApi = `${baseUrl}/ug-programmes`;
export const pgProgrammesApi = `${baseUrl}/pg-programmes`;
export const ugAdmissionApi = `${baseUrl}/ug-admission`;
export const pgAdmissionApi = `${baseUrl}/pg-admission`;
export const facultyMembersApi = `${baseUrl}/faculty-members`;
export const syllabusApi = `${baseUrl}/syllabus`;
export const timeTableManagementApi = `${baseUrl}/time-table-management`;
export const departmentNoticesApi = `${baseUrl}/department-notices`;
export const bedProgrammeApi = `${baseUrl}/b-ed-programme`;
export const medProgrammeApi = `${baseUrl}/m-ed-programme`;
export const bElEdProgrammeApi = `${baseUrl}/b-el-ed-programme`;
export const bPEdMPEdProgrammeApi = `${baseUrl}/b-p-ed-m-p-ed-programme`;
export const ongcCentreApi = `${baseUrl}/ongc-centre`;
export const facultyDepartmentApi = `${baseUrl}/faculties`;

// Examination
export const examinationScheduleApi = `${baseUrl}/examination-schedule`;
export const resultsApi = `${baseUrl}/results`;
// Pointing directly to local Examination Schedule API (bypassing Azure until it is redeployed)
export const examinationLinksApi = `${baseUrl}/examination-schedule/exam-links/links`;

// Facilities
export const gymnasiumApi = `${baseUrl}/gymnasium`;
export const yogaApi = `${baseUrl}/yoga`;
export const indoorSportsApi = `${baseUrl}/indoor-sports`;
export const outdoorSportsApi = `${baseUrl}/outdoor-sports`;
export const htlApi = `${baseUrl}/happy-thinking-laboratory`;
export const placementCellApi = `${baseUrl}/placement-cell`;
export const studentHostelsApi = `${baseUrl}/student-hostels`;
export const canteensApi = `${baseUrl}/canteens`;

// Library
export const ugLibraryApi = `${baseUrl}/ug-library`;
export const pgLibraryApi = `${baseUrl}/pg-library`;

// Media & Contact
export const photoGalleryApi = `${baseUrl}/photo-gallery`;
export const videosApi = `${baseUrl}/videos`;
export const collegeInNewsApi = `${baseUrl}/college-in-news`;
export const pressReleaseApi = `${baseUrl}/press-release`;
export const socialMediaApi = `${baseUrl}/social-media`;
export const vacanciesApi = `${baseUrl}/vacancies`;
export const recruitmentApi = `${baseUrl}/recruitment-portal`;
export const formsGuidelinesApi = `${baseUrl}/forms-guidelines`;
export const contactDirectoryApi = `${baseUrl}/contact-directory`;
export const addressMapApi = `${baseUrl}/address-map`;
export const loginApi = `${baseUrl}/login/login`;
export const userCreationApi = `${baseUrl}/usercreation`;
export const bannerApi = `${baseUrl}/banner`;
export const popupEnquiryApi = `${baseUrl}/popup-enquiry`;
export const studentQueriesApi = `${baseUrl}/student-queries`;
export const dynamicCommitteesApi = `${baseUrl}/dynamic-committees`;
export const studentTestimonialApi = `${baseUrl}/student-testimonial`;

// ─── Legacy ENDPOINTS object (kept for backward compatibility) ────────────────
export const ENDPOINTS = {
  chairman: chairmanApi,
  viceChairman: viceChairmanApi,
  registrar: registrarApi,
  financeOfficer: financeOfficerApi,
  headsOfDepartments: headsOfDepartmentsApi,
  chiefProctor: chiefProctorApi,
  deanStudentsWelfare: deanStudentsWelfareApi,
  admissionCell: admissionCellApi,
  hostelAdministrators: hostelAdministratorsApi,
  facultyAdministrators: facultyAdministratorsApi,
  proctorialOfficials: proctorialOfficialsApi,
  executiveCouncil: executiveCouncilApi,
  academicCouncil: academicCouncilApi,
  financeCommittee: financeCommitteeApi,
  history: historyApi,
  visionMission: visionMissionApi,
  collegeAtGlance: collegeAtGlanceApi,
  collegeKulgeet: collegeKulgeetApi,
  academicHeritage: academicHeritageApi,
  termsAndConditions: termsAndConditionsApi,
  academicCalendar: academicCalendarApi,
  ugProgrammes: ugProgrammesApi,
  pgProgrammes: pgProgrammesApi,
  ugAdmission: ugAdmissionApi,
  pgAdmission: pgAdmissionApi,
  facultyMembers: facultyMembersApi,
  syllabus: syllabusApi,
  timeTables: timeTableManagementApi,
  departmentNotices: departmentNoticesApi,
  bedProgramme: bedProgrammeApi,
  medProgramme: medProgrammeApi,
  bElEdProgramme: bElEdProgrammeApi,
  bPEdMPEdProgramme: bPEdMPEdProgrammeApi,
  facultyDepartment: facultyDepartmentApi,
  examinationSchedule: examinationScheduleApi,
  examinationLinks: examinationLinksApi,
  results: resultsApi,
  gymnasium: gymnasiumApi,
  yoga: yogaApi,
  indoorSports: indoorSportsApi,
  outdoorSports: outdoorSportsApi,
  htl: htlApi,
  placementCell: placementCellApi,
  studentHostels: studentHostelsApi,
  canteens: canteensApi,
  ugLibrary: ugLibraryApi,
  pgLibrary: pgLibraryApi,
  photoGallery: photoGalleryApi,
  videos: videosApi,
  collegeInNews: collegeInNewsApi,
  pressRelease: pressReleaseApi,
  socialMedia: socialMediaApi,
  vacanciesInCollege: vacanciesApi,
  recruitmentPortal: recruitmentApi,
  formsGuidelines: formsGuidelinesApi,
  contactDirectory: contactDirectoryApi,
  addressMap: addressMapApi,
  banner: bannerApi,
  popupEnquiry: popupEnquiryApi,
  studentQueries: studentQueriesApi,
  studentTestimonial: studentTestimonialApi,
};
